import { Component, HostListener, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CourseService } from 'src/app/services/course.service';
import { UsersService } from 'src/app/services/users.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-student-management',
  templateUrl: './student-management.component.html',
  styleUrls: ['./student-management.component.scss']
})
export class StudentManagementComponent implements OnInit {

  constructor(private usersService: UsersService, private courseService: CourseService, private toastrService: ToastrService) { }
  public categories: any[] = ["Hematology",
    "Quality",
    "Cytology",
    "Bio-Chemistry",
    "Micro-Biology",
    "General",
    "Quality Assurance",
    "Samples & Pre-Analytics",
    "Clinical Chemistry",
    "Clinical Pathology",
    "Transfusion Medicine",
    "Immunoassay"];
  public selectedCategory: any = '';
  public selectedMenu: boolean = false;
  public isMenu: boolean = false;
  public usersDetails: any[] = [];
  public isUserInfoSelected: boolean = false;
  public selectedUser: any;
  public enrollFilter: string = 'all';

  ngOnInit(): void {
    this.getUsersDetails();
  }

  onSelectCategory(category) {
    this.selectedCategory = this.selectedCategory !== category ? category : '';
    this.getUsersDetails();
  }

  getUsersDetails() {
    let body = {
      category: this.selectedCategory
    }
    this.usersService.getAllUsersDetails(body).subscribe(
      (res: any) => {
        this.usersDetails = _.cloneDeep(res);
        for (let user of this.usersDetails) {
          if (this.enrollFilter === 'all')
            user['courses'] = [...user['courses'], ...user['restrictedCourses']];
          else if (this.enrollFilter === 'pending')
            user['courses'] = [...user['restrictedCourses']]
          else
            user['courses'] = [...user['courses']]
        }
        this.usersDetails = [...this.usersDetails];
      }
    );
  }

  restrictOrEnable(user, course, type) {
    // console.log(course);
    this.courseService.restrictOrEnableCourseForUser(user._id, course._id, type).subscribe(
      (res: any) => {
        let result = type == 'restrict' ? 'restricted' : 'enabled';
        this.toastrService.success(`Course ${result} successfully!`);
        this.getUsersDetails();
      }
    )
  }

  onChangeEnrollFilter(filter) {
    this.enrollFilter = filter;
    this.getUsersDetails();
  }

  isCourseRestricted(courseId, restrictedCourses) {
    let course = _.filter(restrictedCourses, rc => { return rc._id == courseId })[0];
    return !_.isEmpty(course);
  }

  onClickUserInfo(user) {
    this.selectedUser = user;
    this.isUserInfoSelected = true;
  }

  onCloseUserInfo(event) {
    if (event == 'close') {
      this.isUserInfoSelected = false;
      this.selectedUser = {};
    }
  }

}
